import { useMutation } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface UpdateUserEmailParams {
  userId: string;
  newEmail: string;
}

export const useUpdateUserEmail = () => {
  return useMutation({
    mutationFn: async ({ userId, newEmail }: UpdateUserEmailParams) => {
      const { data, error } = await supabase.functions.invoke(
        "admin-update-user-email",
        {
          body: { userId, newEmail },
        }
      );

      if (error) {
        // Intentar extraer el error del cuerpo de la respuesta
        const message =
          (data as { error?: string } | null)?.error ||
          error.message ||
          "Error al actualizar el email";
        throw new Error(message);
      }

      if (data?.error) {
        throw new Error(data.error);
      }

      return data as { success: boolean; email: string };
    },
  });
};
